import Link from "next/link";

export default function NotFound() {
  return (
    <section className="flex min-h-[80vh] flex-col justify-end px-5 py-20 md:px-8">
      <p className="font-mono text-brass">404</p>
      <h1 className="font-display mt-4 text-6xl md:text-8xl">Cible manquée.</h1>
      <Link href="/" className="mt-10 inline-flex w-fit rounded-sm bg-brass px-6 py-3 text-xs tracking-[0.18em] text-ink uppercase">
        Retour au stand
      </Link>
    </section>
  );
}
